/* eslint-disable no-extend-native */

declare global {
  interface Promise<T> {
    peek(callback: (arg: T) => void): Promise<T>;
  }

  interface PromiseWithResolvers<T> {
    promise: Promise<T>;
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason?: any) => void;
  }

  interface PromiseConstructor {
    withResolvers<T>(): PromiseWithResolvers<T>;
  }
}

Promise.prototype.peek = function <T>(this: Promise<T>, callback: (arg: T) => void) {
  return this.then((it) => {
    callback(it);
    return it;
  });
};

if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function <T>(): PromiseWithResolvers<T> {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export default {};
